export default __webpack_public_path__ + "static/media/ErrorImage.be53aee3.png";